/* import logo from './logo.svg'; */
import './App.css';

function App() {
  return (
    <div className="App">
         {/* <li key={module.name} className={currentTab === module.name ? 'active' : ''}>
            <Link to={module.routeProps.path} onClick={() => setCurrentTab(module.name)}>{module.name}</Link>
          </li> */}
    </div>
  );
}

export default App;
